<template>
  <div class="content">
    <v-row>
      <v-col cols="12" sm="9">
        <h1 class="title">
          {{ $t("capacitySettings.title") + " - " + productName }}
        </h1>
      </v-col>
      <v-col cols="12" sm="3" class="align">
        <v-btn @click="handleCreateCapacitySettings()" color="primary">
          {{ $t("capacitySettings.create") }}
        </v-btn>
      </v-col>
    </v-row>
    <div class="table">
      <table-list-users
        v-if="!isLoading"
        :headerList="tableHeaders"
        :userList="users"
        :seenAttrs="userSeenAttrs"
        :itemActionList="actions"
        userType="capacitySettings"
        @buttonClicked="handleActionClicked"
        @userChanged="handleCapacitySettingsEdit"
        @userDelete="handleCapacitySettingsDelete"
      />
      <v-card v-else class="loading">
        <v-progress-circular
          v-if="isLoading"
          size="73.5"
          indeterminate
          class="loading-circle"
        ></v-progress-circular>
      </v-card>
    </div>
  </div>
</template>

<script>
import TableListUsers from "@/components/global/tableListComponents/TableListUsers";
import { mapActions } from "vuex";
import EditcapacitySettingsModalVue from "@/components/global/modalComponents/EditcapacitySettingsModal/EditcapacitySettingsModal.vue";
import Swal from "sweetalert2";
import moment from "moment";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "CapacitySettings",
  props: {},
  components: {
    TableListUsers,
  },
  data() {
    return {
      users: [],
      userSeenAttrs: ["webshop_user_type", "start_date", "end_date", "limit"],
      actions: [
        {
          icon: "mdi-edit",
          type: "edit",
        },
      ],
      isLoading: true,
      productName: "",
    };
  },
  created() {
    this.emitter.on("userDeleteConfirm", this.handleCapacitySettingsDelete);
    this.emitter.on("buttonClicked", this.handleActionClicked);
  },
  mounted() {
    this.getCapacitySettingsListMethod();
  },
  methods: {
    ...mapActions({
      getCapacitySettings: "products/getCapacitySettings",
      createCapacitySettings: "products/createCapacitySettings",
      editCapacitySettings: "products/editCapacitySettings",
      deleteCapacitySettings: "products/deleteCapacitySettings",
    }),

    getCapacitySettingsListMethod() {
      this.isLoading = true;
      this.getCapacitySettings(this.$route.params.id)
        .then((res) => {
          this.productName = res.product.name;
          this.users = res.list;

          //FORMAT TABLE DATAS
          if (this.users.length > 0) {
            for (let item in this.users) {
              this.users[item].limit = `${this.users[item].limit}%`;

              this.users[item].start_date = this.formatDate(
                this.users[item].start_date
              );

              this.users[item].end_date = this.formatDate(
                this.users[item].end_date
              );

              this.users[item].webshop_user_type =
                this.users[item].webshop_user_type.title;
            }

            const hasHundredPercent = this.users.some((item) => {
              return item.limit == "100%";
            });
            if (!hasHundredPercent) {
              Swal.fire({
                titleText: this.$t("capacitySettings.message"),
              });
            }
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },

    handleCreateCapacitySettings() {
      this.emitter.emit("showComponentModalModal", {
        bind: {
          is: EditcapacitySettingsModalVue,
          isCreate: true,
        },
        on: {
          createNewCapacitySettings: (createPayload) => {
            this.createCapacitySettings(createPayload)
              .then(() => {
                toast.success(this.$t("capacitySettings.toast.successCreate"));
                this.getCapacitySettingsListMethod();
              })
              .catch(() => {});
          },
        },
      });
    },

    handleCapacitySettingsDelete(id) {
      this.isLoading = true;
      this.deleteCapacitySettings({ id: id, product_id: this.$route.params.id })
        .then(() => {
          this.isLoading = false;
          toast.success(this.$t("capacitySettings.toast.successDelete"));
          this.getCapacitySettingsListMethod();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    handleCapacitySettingsEdit(createPayload) {
      this.isLoading = true;
      this.editCapacitySettings(createPayload)
        .then(() => {
          this.isLoading = false;
          toast.success(this.$t("capacitySettings.toast.successEdit"));
          this.getCapacitySettingsListMethod();
        })
        .catch(() => {
          this.isLoading = false;
        });
      console.log("handleCapacitySettingsEdit");
    },

    formatDate(dateString) {
      return moment(dateString).format("YYYY.MM.DD");
    },
  },
  computed: {
    tableHeaders() {
      const headers = [
        {
          title: this.$t("capacitySettings.table.headers.type"),
          textAlign: "text-left",
          value: "ticketBuyerType",
        },
        {
          title: this.$t("capacitySettings.table.headers.date_from"),
          textAlign: "text-left",
          value: "date_from",
        },
        {
          title: this.$t("capacitySettings.table.headers.date_to"),
          textAlign: "text-left",
          value: "date_to",
        },
        {
          title: this.$t("capacitySettings.table.headers.capacity_limit"),
          textAlign: "text-left",
          value: "capacity",
        },
        {
          title: this.$t("capacitySettings.table.headers.edit"),
          textAlign: "text-right",
          value: "actions",
        },
      ];
      return headers;
    },
  },
  beforeUnmount() {
    this.emitter.off("userDeleteConfirm", this.handleCapacitySettingsDelete);
  },
};
</script>

<style lang="scss" scoped>
.align {
  text-align: end;
}

@media (max-width: 599px) {
  .align {
    text-align: start;
  }
}
</style>
